import React, {useMemo} from "react";
import {AutoVisitStatusV2} from "~/apps/packages/auto-visits/queries";
import {StatusBadge, StatusBadgeProps} from "~/apps/core/ui/StatusBadge";
import {getAutoVisitStatusColor} from "~/apps/packages/auto-visits/utils";


export type AutoVisitStatusBadgeProps = Omit<StatusBadgeProps<AutoVisitStatusV2>, "badgeColor">;


export const AutoVisitStatusBadge = (props: AutoVisitStatusBadgeProps) => {
    const {children, ...otherProps} = props;
    const status = useMemo(() => children, [children]);
    const badgeColor = useMemo(() => getAutoVisitStatusColor(status), [status]);

    return (
        <StatusBadge {...otherProps} badgeColor={badgeColor} outlined={false}>
            {status}
        </StatusBadge>
    )
}